import { IThreeContextData } from '@src/services/ThreeContext';
import React from 'react';
import * as THREE from 'three';
import { OrbitControls } from 'three/examples/jsm/Addons.js';
import Stats from 'three/examples/jsm/libs/stats.module.js';
import ThreePresentation from '../../ThreePresentation/ThreePresentation';

const GlobusScene: React.FC = () => {

    const onStart = React.useCallback(
        (context: IThreeContextData) => {
            context.renderer.setClearColor(0x000000, 0);

            const stats = new Stats();
            stats.dom.style.position = "absolute";

            context.container.appendChild(stats.dom);

            // camera
            context.camera.position.set(1, 1, 1);
            context.camera.rotateY(Math.PI / 4);
            context.camera.rotateX(-Math.PI / 5);

            const loadManager = new THREE.LoadingManager(
                //() => togglePending(false),
                //(url, loaded, total) => setProgress([loaded, total])
            );

            // textures & materials
            const mapTexture = new THREE
                .TextureLoader(loadManager)
                .load("https://upload.wikimedia.org/wikipedia/commons/thumb/2/23/Blue_Marble_2002.png/1920px-Blue_Marble_2002.png");

            mapTexture.anisotropy = 16;

            const mapMaterial = new THREE.MeshPhongMaterial({
                color: 0xFFFFFF,
                map: mapTexture,
                specular: 0x222222,
            });

            const pivot = new THREE.Object3D();
            pivot.rotateY(-Math.PI / 1.75);
            context.scene.add(pivot);

            // map
            const mapSphereGeometry = new THREE.SphereGeometry(0.5, 128, 64);
            const mapSphere = new THREE.Mesh(mapSphereGeometry, mapMaterial);
            pivot.add(mapSphere);

            // light
            const ambientLight = new THREE.AmbientLight(0x999999);
            context.scene.add(ambientLight);

            const directionalLight = new THREE.DirectionalLight(0xFFFFFF, 1);
            directionalLight.position.set(1, 0.5, 1);
            directionalLight.target = mapSphere;
            context.scene.add(directionalLight);

            const directionalLight2 = new THREE.DirectionalLight(0xFFFFFF, 0.33);
            directionalLight2.position.set(-1, -0.5, -1);
            directionalLight2.target = mapSphere;
            context.scene.add(directionalLight2);

            const controls = new OrbitControls(context.camera, context.canvas);
            controls.enableRotate = true;
            controls.enableZoom = true;
            controls.enablePan = false;
            controls.minDistance = 1;
            controls.maxDistance = 2;

            return {
                stats,
                pivot,
                controls,
            };
        },
        []
    );

    const onUpdate = React.useCallback(
        (context: IThreeContextData, state: ReturnType<typeof onStart>) => {
            state.pivot.rotateY(context.deltaTime * 0.00001);
            state.controls.update();
            state.stats.update();
        },
        []
    );

    return (
        <div>
            <ThreePresentation
                onStart={onStart}
                onUpdate={onUpdate}
            />
        </div>
    )
};

export default GlobusScene;